// libraries
import * as offerActionTypes from '@makemydeal/dr-dash-store/actionTypes/offerActionTypes';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { useSelector } from 'react-redux';

// consts/enums
import {
    ADJUSTED_RESIDUAL_DOLLAR_TESTID,
    ADJUSTED_RESIDUAL_GROUP_TESTID,
    ADJUSTED_RESIDUAL_GROUPID,
    ADJUSTED_RESIDUAL_ID,
    ADJUSTED_RESIDUAL_LABEL,
    ADJUSTED_RESIDUAL_PERCENT_TESTID,
    ADJUSTED_RESIDUAL_VALUE_TESTID
} from '../../../constants';

// utils
import { isEqual } from 'lodash';
import { useFeatureToggle } from '../../../utils/useFeatureToggle';
import { useHeldSelector } from '../../../hooks/useHeldSelector';
import type { ResidualFieldInputProps } from './useResidualField';

export const useAdjustedResidualInputProps = (): { isReadOnlyDisplay: boolean; inputProps: ResidualFieldInputProps } => {
    // Adjusted Residual is read-only when enabled.
    const isLeaseResidualTreatmentEnabled = useFeatureToggle('enableLeaseResidualTreatment_F286227');

    const { adjustedResidualType, adjustedResidualAmount, adjustedResidualPercent } = useSelector(
        offerSelectors.getResidualInfoOverrideWithFallback,
        isEqual
    );

    const residualValue = useHeldSelector(offerReduxSelectors.getAdjustedResidualValue);
    const residualPercent = useHeldSelector(offerReduxSelectors.getAdjustedResidualPercent);

    const dollar = residualValue || adjustedResidualAmount;
    const percent = residualPercent || adjustedResidualPercent;

    return {
        isReadOnlyDisplay: isLeaseResidualTreatmentEnabled,
        inputProps: {
            residualType: adjustedResidualType,
            residualAmount: dollar,
            residualPercent: percent,
            updateResidualOverride: offerReduxActionCreators.updateAdjustedResidualOverride,
            id: ADJUSTED_RESIDUAL_ID,
            label: ADJUSTED_RESIDUAL_LABEL,
            groupId: ADJUSTED_RESIDUAL_GROUPID,
            groupTestId: ADJUSTED_RESIDUAL_GROUP_TESTID,
            valueTestId: ADJUSTED_RESIDUAL_VALUE_TESTID,
            dollarTestId: ADJUSTED_RESIDUAL_DOLLAR_TESTID,
            percentTestId: ADJUSTED_RESIDUAL_PERCENT_TESTID,
            dollarOverrideAction: offerActionTypes.UPDATED_ADJUSTED_RESIDUAL_DOLLAR_OVERRIDE,
            percentOverrideAction: offerActionTypes.UPDATED_ADJUSTED_RESIDUAL_PERCENT_OVERRIDE
        }
    };
};
